import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=03775904&scoped=true&"
import script from "./ObjectCard.vue?vue&type=script&lang=js&"
export * from "./ObjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&id=03775904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03775904",
  null
  
)

export default component.exports